import React, { useCallback, useEffect, useState } from "react";
import InfoView from "../../../Components/InfoView";
import LoadingView from "../../../Components/LoadingView";
import Api from "../../../Server/Api";
import { MedicalProfileContent } from "../../profile/MedicalProfile";

const api = new Api();

const MedicalProfile = ({ id }) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({});

	const handleGetMedicalProfile = useCallback(async () => {
		setLoading(true);
		const res = await api.get({
			endpoint: `/permission/${id}/medical_profile/`,
		});
		setData(res?.profile);
		setLoading(false);
	}, [id]);

	useEffect(() => {
		handleGetMedicalProfile();
	}, [id, handleGetMedicalProfile]);

	if (loading) {
		return (
			<LoadingView>
				<p>Fetching medical profile...</p>
			</LoadingView>
		);
	}
	if (!data) {
		return (
			<InfoView
				title="No Medical Profile"
				description="This patient does not have a medical profile."
			/>
		);
	}
	return <MedicalProfileContent PROFILE={data} readOnly />;
};

export default MedicalProfile;
